import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Select, Checkbox } from "antd";
import RemovePopoverContent from "../PopoverContent";
import { showHideInput } from "../../../../../../../components/DynamicViewNew/helper";
import { getPopupContainer } from "../../../../../../../helpers/popUp";

const initData = (inputs) => Object.keys(inputs).reduce((all, key) => {
  const conf = inputs[key];
  if (conf.inputType === 'text') {
    all[key] = '';
  }
  if (conf.inputType === 'checkboxGroup') {
    all[key] = [];
  }
  return all;
}, {});

export function useNewItem({ onClose, inputs = {}, isSource }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({ ...initData(inputs), status: 'pending' });

  const onChangeData = (key = '', value = '') => {
    setData((prev) => ({ ...prev, [key]: value }));
  };

  const getDisabled = () => {
    const _disabled = Object.keys(inputs)
      .filter((key) => {
        if (inputs[key].showIf) {
          return showHideInput(inputs[key], data)
        }
        return true;
      })
      .find((key) => !data[key]);

    if (_disabled) {
      return 'errors::Please fill all required fields';
    }

    if (data?.emailOrDSID === 'email') {
      if (
        !String(data.email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
      ) {
        return 'errors::Please add a valid email';
      }
    }

    if (!data?.shareInfo?.length) {
      return 'errors::Please select at least one subject for sharing';
    }
  };

  const disabled = getDisabled();

  const removeContent = (
    <RemovePopoverContent
      onConfirm={onClose}
      title={t(isSource ? 'Are you sure you want to remove this source?' : 'Are you sure you want to remove this client?')}
      body={t('Its information will be removed from the project.')}
      okText={t('Yes')}
      dismissText={t('Dismiss')}
      onClose={() => setVisible(false)}
    />
  );

  const renderInput = (_config, key) => {
    switch (_config.inputType) {
      case 'text':
        return (
          <Input
            value={data[key] || ''}
            placeholder={_config.placeholder || ''}
            onChange={(e) => onChangeData(key, e.target.value)} />
        );
      case 'select':
        return (
          <Select
            value={data[key]}
            placeholder={_config.placeholder || ''}
            {...getPopupContainer()}
            onChange={(v) => onChangeData(key, v)}>
            {(_config.options || []).map((opt) => (
              <Select.Option key={`${key}-${opt.value}`} value={opt.value}>{opt.label}</Select.Option>
            ))}
          </Select>
        );
      case 'checkboxGroup':
        return (
          <div className="list">
            {(_config.options || []).map((opt) => (
              <div className="item" key={`options-${opt.value}`}>
                <Checkbox
                  checked={(data[key] || []).includes(opt.value)}
                  onChange={(e) => {
                    const _new = e.target.checked
                      ? [...(data[key] || []), opt.value]
                      : [...(data[key] || []).filter((val) => val !== opt.value)]

                    onChangeData(key, _new);
                  }}
                />
                <label>{opt.label}</label>
              </div>
            ))}
          </div>
        );
      default:
        return null;
    }
  };

  return {
    t,
    visible,
    setVisible,
    removeContent,
    onChangeData,
    data,
    renderInput,
    disabled,
  };
}
